// Was gehört auf den Zeitnachweis, den ein Kunde zu sehen bekommt?
//
// Zwei Regeln, beide bewusst streng: Nur abrechenbare Buchungen (interne Zeiten sind
// nicht Sache des Kunden, User-Entscheidung 17.08.2026), und nur abgeschlossene — ein
// laufender Timer hat noch kein Ende und taugt nicht als Nachweis.
import { dauerMinuten } from './berechnung';
import type { TicketZeit } from './ticketzeit';

export function nachweisZeilen(zeiten: TicketZeit[]): TicketZeit[] {
  return zeiten
    .filter((z) => z.abrechenbar && !!z.ende)
    .sort((a, b) => Date.parse(a.beginn) - Date.parse(b.beginn));
}

export function nachweisSummeMinuten(zeiten: TicketZeit[]): number {
  return nachweisZeilen(zeiten).reduce((summe, z) => summe + dauerMinuten(z.beginn, z.ende), 0);
}
